/* @flow */
import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Motion, spring } from "react-motion";
import Layers from "./Layers";

import { rgba } from "polished";
import { fontSize } from "../common/styled-mixins";

const Container = styled.div`
  position: absolute;
  top: -84px;
  right: 0;
  width: 42px;
  height: 100%;
  padding-bottom: 84px;
  box-sizing: content-box;
  z-index: ${Layers.SENTIMENTS};

  ${props =>
    props.mobile &&
    css`
      right: auto;
      left: 0;
      top: 24px;
      height: calc(100% - 24px);
      padding-bottom: 0;
    `};
`;

const ContainerCell = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  width: 100%;
  
  ${({ mobile }) => mobile && css`
    right: auto;
    left: 0;
  `};
`;

const Text = styled.div`
  position: absolute;
  left: 0;
  transform: translateY(-7px);
  font-size: ${fontSize(13, 13)};
  line-height: 1;
  color: ${({ theme }) => rgba(theme.foreground, 0.5)};

  ${props =>
    props.mobile &&
    css`
      right: auto;
      left: 5px;
      transform: translateY(-13.5px);
      padding: 2px;
      font-size: ${fontSize(10, 10)};
      background-color: ${props => props.theme.mainDark};
      border-radius: 2px;
    `};
`;

const UpDown = styled.span`
  ${props =>
    props.mobile &&
    css`
      display: block;
      text-align: center;
    `};
`;

const UpText = styled(UpDown)`
  color: ${({ theme }) => theme.upper};
`;

const DownText = styled(UpDown)`
  color: ${({ theme }) => theme.lower};
`;

const Divider = styled.span`
  ${props =>
    props.mobile &&
    css`
      display: block;
      margin: 1px 0;
      border-bottom: 1px solid ${({ theme }) => theme.background};
    `};
`;

const BarContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 3px;
  height: 100%;
  background-color: ${({ theme }) => theme.upper};
  
  ${({ mobile }) => mobile && css`
    right: auto;
    left: 0;
  `};
`;

const Bar = styled.div`
  width: 3px;
  height: 50%;
  background-color: ${({ theme }) => theme.lower};
  border-bottom: 1px solid ${({ theme }) => theme.main};
`;

type Props = {
  positive: number,
  mobile?: Boolean
};

function Sentiments(props: Props) {
  const up = Math.round(props.positive * 1e5) / 10e2;
  const down = 100 - up;

  return (
    <Container mobile={props.mobile}>
      <ContainerCell mobile={props.mobile}>
        <Text style={{ top: `${down}%` }} mobile={props.mobile}>
          <DownText mobile={props.mobile}>{Math.round(down)}</DownText>
          <Divider mobile={props.mobile}>{!props.mobile ? "/" : null}</Divider>
          <UpText mobile={props.mobile}>{Math.round(up)}</UpText>
        </Text>

        <BarContainer mobile={props.mobile}>
          <Bar style={{ height: `${down}%` }} />
        </BarContainer>
      </ContainerCell>
    </Container>
  );
}

type AnimatedProps = {
  stats: {
    upper: number,
    lower: number
  }
};

class AnimatedSentiments extends Component<AnimatedProps> {
  render() {
    const { stats } = this.props;

    // если stats отсутствует,
    // проставляем 0.5 (=50%)
    const positive =
      typeof stats !== "object"
        ? 0.5
        : (stats.upper + 1) / (stats.upper + stats.lower + 2);

    return (
      <Motion style={{ positive: spring(positive) }}>
        {props => <Sentiments positive={props.positive} {...this.props} />}
      </Motion>
    );
  }
}

export default AnimatedSentiments;



// WEBPACK FOOTER //
// ./src/components/Chart/Sentiments.js